import React from "react";
import style from "../../sass/skill.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { skillAction } from "../../redux/skillSlice";
const SkillButtons = () => {
     const { activeButton } = useSelector((state) => state.skill);
     const disptach = useDispatch();

     const handleActiveButton = (e) => {
          disptach(skillAction.updateTargetButton(e.target.textContent));
     };
     return (
          <div className={style.skill_buttons}>
               <button onClick={handleActiveButton} className={activeButton === "All" ? style.skill_buttons_active : style.skill_buttons_btn}>
                    All
               </button>
               <button onClick={handleActiveButton} className={activeButton === "Language" ? style.skill_buttons_active : style.skill_buttons_btn}>
                    Language
               </button>
               <button onClick={handleActiveButton} className={activeButton === "Frontend" ? style.skill_buttons_active : style.skill_buttons_btn}>
                    Frontend
               </button>
               <button onClick={handleActiveButton} className={activeButton === "Backend" ? style.skill_buttons_active : style.skill_buttons_btn}>
                    Backend
               </button>
               <button onClick={handleActiveButton} className={activeButton === "Tools" ? style.skill_buttons_active : style.skill_buttons_btn}>
                    Tools
               </button>
          </div>
     );
};
export default SkillButtons;
